import { render, staticRenderFns } from "./DonorVerificationFix.vue?vue&type=template&id=454ea2d9"
import script from "./DonorVerificationFix.vue?vue&type=script&lang=js"
export * from "./DonorVerificationFix.vue?vue&type=script&lang=js"
import style0 from "./DonorVerificationFix.vue?vue&type=style&index=0&id=454ea2d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports